import { render, staticRenderFns } from "./SocialGroup.vue?vue&type=template&id=54c5ad8e&scoped=true&"
import script from "./SocialGroup.vue?vue&type=script&lang=js&"
export * from "./SocialGroup.vue?vue&type=script&lang=js&"
import style0 from "./SocialGroup.vue?vue&type=style&index=0&id=54c5ad8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5ad8e",
  null
  
)

component.options.__file = "SocialGroup.vue"
export default component.exports